import React from "react"
import tw from "twin.macro"

import { withSearchFormResults } from "./withSearchFormResults"
import FeaturedProductCard from "../../Product/Card/FeaturedProductCard"

const Results = tw.div`w-full`
const Wrapper = tw.div`flex flex-wrap -mx-0-8 md:-mx-1-6 mt-1-6 md:mt-3-2 md:max-h-60 overflow-y-scroll`
const SeeAllWrapper = tw.div`flex justify-center w-full my-0-8`
const SeeAll = tw.button`leading-1.36 hover:text-dark focus:outline-none cursor-pointer`
const CardWrapper = tw.div`w-1/2 md:w-1/3`

export const SearchFormResults = withSearchFormResults(({ handleClick, items }) => (
  <>
    {items?.length > 0 && (
      <Results>
        <Wrapper>
          {items?.map((item, index) => {
            return (
              <CardWrapper key={index}>
                <FeaturedProductCard index={index + 1} product={item} type={`collection`} />
              </CardWrapper>
            )
          })}
          <SeeAllWrapper>
            <SeeAll className={`underlined-black`} onClick={handleClick}>
              <span>See all</span>
            </SeeAll>
          </SeeAllWrapper>
        </Wrapper>
      </Results>
    )}
  </>
))
